export enum Endpoints {
    USER = 'user',
    PORTAL_LIST = 'portallist',
    DEPLOYMENT = 'deployment',
    METRICS = 'metrics',
    VERSION = 'version',
    UPGRADE = 'upgrade',
    EXTERNAL_STORAGE = 'externalstorage',
    AUDIT = 'audit',
    DEPLOYMENTS = 'deployments'
}
